import {LivetickerAssignmentDialog} from 'app/components/match/matchLive/LivetickerAssignmentDialog';
import {RequestErrorHandler} from 'app/components/match/matchLive/LivetickerCommon';
import React, {useState} from 'react';
import {authorizedAPI} from 'app/services/api';
import LivetickerAction from 'app/components/match/LivetickerAction';
import LoginHint from 'app/components/match/LoginHint';

const postTicker = slug => {
  return authorizedAPI.post(`/matches/${slug}/ticker`);
};

const unauthenticatedError = {message: 'Du musst eingeloggt sein, um diese Aktion durchzuführen.', code: 401};

const LivetickerAvailable = ({fuPaUser, reloadData, matchSlug}) => {
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [isAssigningTicker, setIsAssigningTicker] = useState(false);

  const handleTickerAssign = async () => {
    setIsAssigningTicker(true);
    try {
      await postTicker(matchSlug);
      setIsAssigningTicker(false);
      reloadData();
    } catch (error) {
      setError(RequestErrorHandler(error, matchSlug));
      setIsAssigningTicker(false);
    }
  };

  const registerLiveticker = () => {
    if (!fuPaUser?.id) {
      setError(unauthenticatedError);
      return;
    }

    if (fuPaUser.tickerCount <= 1) {
      setOpen(true);
      return;
    }

    return handleTickerAssign();
  };

  const handleAccept = async () => {
    await handleTickerAssign();
    setOpen(false);
  };

  const shownError = error ? (
    <span>
      {error?.message} {error?.code === unauthenticatedError.code ? <LoginHint /> : null}
    </span>
  ) : null;

  return (
    <>
      <LivetickerAction
        buttonType='primary'
        descriptiveText='Es ist noch kein Liveticker-Melder eingetragen. 😔'
        error={shownError}
        isLoading={isAssigningTicker}
        label='Liveticker übernehmen'
        onClick={registerLiveticker}
      />
      <LivetickerAssignmentDialog open={open} onClose={() => setOpen(false)} onAccept={handleAccept} />
    </>
  );
};

export default LivetickerAvailable;
